export default __webpack_public_path__ + "static/media/etavastaanotto-grey.d7e9390a.svg";